<template>

  <!-- 浮动导航 -->
  <nav right class="floating-nav">
    <v-list dense>
      <v-list-item to="/zh/services">
        <v-list-item-title>我们的服务</v-list-item-title>
      </v-list-item>
      <v-list-item to="/zh/services/audit">
        <v-list-item-title> <v-icon class="mr-2">mdi-text-box-check-outline</v-icon>审计</v-list-item-title>
      </v-list-item>
      <v-list-item to="/zh/services/tax">
        <v-list-item-title> <v-icon class="mr-2">mdi-cash-check</v-icon>税务</v-list-item-title>
      </v-list-item>
      <v-list-item to="/zh/services/accounting">
        <v-list-item-title> <v-icon class="mr-2">mdi-abacus</v-icon>会计</v-list-item-title>
      </v-list-item>
      <v-list-item to="/zh/services/consulting">
        <v-list-item-title> <v-icon class="mr-2">mdi-account-question-outline</v-icon>咨询</v-list-item-title>
      </v-list-item>
    </v-list>
  </nav>
</template>

<script setup>
</script>

<style scoped>
.floating-nav {
  position: -webkit-sticky;
  /* Safari */
  position: sticky;
  margin-left: 150px;
  width: 160px;
  top: 60px;
  /* 根据需要调整距离顶部的距离 */
  background-color: white;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
